import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs as defaultFaqs, faqTitle } from '../data/content';
import type { FaqItem } from '../data/content';
interface FaqProps {
  faqs?: FaqItem[];
}
export function Faq({
  faqs = defaultFaqs
}: FaqProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="tint" title={faqTitle} data-id="element-58" data-mp="2dz4w3xjyf0dq">
      <ul className="mx-auto max-w-4xl space-y-3" data-id="element-59" data-mp="2dy3j3njdo3td">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-blue-100" data-id="element-60" data-mp="2418imz3jntcg" data-mpi={index}>
              <h3 data-id="element-61" data-mp="sn3cq0jrt9eh">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-200 md:px-7" data-id="element-62" data-mp="snmp71qnj5l4">
                  <span className="text-lg font-extrabold tracking-tight text-slate-900" data-id="element-63" data-mp="fiqgkbrlz4wr">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-blue-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-64" data-mp="6rgc3pf1toda" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-65" data-mp="1s3qt93tspct">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-66" data-mp="1q0phsx839ss">
                    <p className="px-5 pb-6 text-lg text-blue-900/75 md:px-7" data-id="element-67" data-mp="1pp35udj3nkdm">{faq.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}